import { Routes } from "./routes";
import "./scss/App.scss";

function App() {
	return <Routes />;
}

export default App;
